var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 11.9507C1.3335 11.5458 1.43669 11.1476 1.63333 10.7936L5.75727 3.37054C6.12282 2.71254 6.75887 2.24826 7.49697 2.10064V2.10064C7.82914 2.0342 8.17118 2.0342 8.50335 2.10064V2.10064C9.24145 2.24826 9.8775 2.71254 10.2431 3.37054L14.367 10.7936C14.5636 11.1476 14.6668 11.5458 14.6668 11.9507V11.9507C14.6668 13.2666 13.6001 14.3333 12.2842 14.3333H3.7161C2.40022 14.3333 1.3335 13.2666 1.3335 11.9507V11.9507Z",
    stroke: "#F24848",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.00008L8 8.66675",
    stroke: "#F24848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.6667L8 11",
    stroke: "#F24848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.758b294b641915015c9037fb6fdc59d9.svg";
export { ForwardRef as ReactComponent };